<template>
  <other-order :type="4"></other-order>
</template>
<script>
import otherOrder from "_my/other-order";
export default {
  name: "noon",
  components: {
    otherOrder
  }
};
</script>
